export const styles = {
  container: "flex items-center justify-between mb-5",
  left: "flex items-center text-xs font-normal text-black lg:text-base",
  spacer: "mr-3",
  right: "flex items-center justify-between space-x-4",
  amount: "text-xs font-normal text-black lg:text-base",
  currency: "text-xs font-normal text-black lg:text-base",
};
